import React from "react";
import {Card, Space, Tabs, Typography} from "antd";
import {EyeOutlined, LinkedinOutlined, InstagramOutlined, FacebookOutlined} from "@ant-design/icons";

import LinkedInPreview from "../Tabs/LinkedInPreview";
import InstagramPreview from "../Tabs/InstagramPreview";
import FacebookPreview from "../Tabs/FacebookPreview";
import ThreadsPreview from "../Tabs/ThreadsPreview";
import threadsIcon from "../../pages/icons/threads-mini.svg";

/**
 * props:
 * - text: строка текста для предпросмотра (у вас: editMainText ? mainText : post?.post)
 * - serverImages: массив строк или объектов { url | path | src }
 * - profileName: подпись аккаунта/страницы
 */
export default function LivePreviewCard({text, serverImages, profileName, videoUrl, threadsHandle, verified, captionSource, attachmentSource, isIgStories}) {

    const serverUrls = React.useMemo(() => normalizeServerImages(serverImages), [serverImages]);

    const previewImages = (serverUrls).filter((i) => !!i.url);

    const textForPreview = (attachmentSource || text || "").trim();

    return (
        <Card className="shadow-sm" bodyStyle={{padding: 16}}>
            <Space align="center" size={8} style={{marginBottom: 8}}>
                <EyeOutlined/>
                <Typography.Title level={5} style={{margin: 0}}>Live Preview</Typography.Title>
            </Space>

            <Tabs defaultActiveKey="instagram">
                <Tabs.TabPane tab={<Space><LinkedinOutlined/>LinkedIn</Space>} key="linkedin">
                    <LinkedInPreview
                        text={textForPreview}
                        images={previewImages}
                        profileName={profileName}
                    />
                </Tabs.TabPane>

                <Tabs.TabPane tab={<Space><InstagramOutlined/>Instagram</Space>} key="instagram">
                    <InstagramPreview
                        text={textForPreview}
                        images={previewImages}
                        profileName={profileName}
                        videoUrl={videoUrl}
                        mode={isIgStories ? 'story' : 'post'}
                    />
                </Tabs.TabPane>

                <Tabs.TabPane tab={<Space><FacebookOutlined/>Facebook</Space>} key="facebook">
                    <FacebookPreview
                        text={textForPreview}
                        images={previewImages}
                        profileName={profileName}
                    />
                </Tabs.TabPane>

                <Tabs.TabPane
                    tab={
                        <Space>
                            <img src={threadsIcon} alt="Threads" style={{ width: 16, height: 16 }} />
                            Threads
                        </Space>
                    }
                    key="threads"
                >
                    <ThreadsPreview
                        captionSource={captionSource}
                        attachmentSource={textForPreview}
                        images={previewImages}
                        profileName={profileName}
                        threadsHandle={threadsHandle}
                        verified={verified}
                        videoUrl={videoUrl}
                    />
                </Tabs.TabPane>
            </Tabs>
        </Card>
    );
}

const normalizeServerImages = (items = []) =>
    items
        .map((it) => {
            if (!it) return null;
            if (typeof it === "string") return { url: it };
            const url = it.imageUrl || it.url || it.path || it.src || "";
            return url ? { url } : null;
        })
        .filter(Boolean);